module.exports = __webpack_public_path__ + "media/images/flags/4x3/flk-55f09b0a4d5000fef70b50d4d09c250b.svg";